import React, { Fragment, useState, useEffect } from 'react'
import { Stepper, Button, Group, TextInput, Radio, Title, Text, Select, Textarea, CloseButton, Notification, Tooltip, Modal } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { MdOutlineAlternateEmail, MdOutlinePhoneEnabled, MdOutlineDateRange } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { GrDocumentText } from "react-icons/gr";
import UploadFile from '../../shared/UploadFile';
import { useSelector } from 'react-redux';
import { postFormData, postData, getData } from 'views/Website/services/fetch-service';
import { FaCheck, FaInfoCircle } from 'react-icons/fa';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Values from './Values';
import CopyToClipboard from 'react-copy-to-clipboard';
import { RxCross1 } from 'react-icons/rx';
import dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const KonfliktInteresit = () => {
    const [active, setActive] = useState(0);
    const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current));
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [idKonflikti, setIdKonflikti] = useState();
    const [referenceKonflikti, setReferenceKonflikti] = useState();
    const baseUrl = process.env.REACT_APP_BASEURL

    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ContentTranslations = useSelector((state) => state.WebsiteLanguage.data.ContentTranslations);
    const ValidationTranslations = useSelector((state) => state.WebsiteLanguage.data.ValidationTranslations);
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);
    const institutionsData = useSelector((state) => state.WebsiteLanguage.data.Instuticionet);

    const maxChars = 2500;

    const getValidationSchema = (activeStep) => {
        if (activeStep === 0) {
            return Yup.object().shape({
                raportuesiEmri: Yup.string().when('raportuesiAnonim', {
                    is: "false",
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                raportuesiMbiemri: Yup.string().when('raportuesiAnonim', {
                    is: "false",
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                // raportuesiEmail: Yup.string().email(ValidationTranslations.validEmail).required(ValidationTranslations.requiredField),
                // ConfirmEmailRaportuesi: Yup.string().email(ValidationTranslations.validEmail)
                //     .oneOf([Yup.ref('raportuesiEmail'), null], ValidationTranslations.confirmEmail)
                //     .required(t('translation.required')),
                raportuesiGjiniaId: Yup.string().required(ValidationTranslations.requiredField),
            });
        } else if (activeStep === 1) {
            return Yup.object().shape({
                konfliktNdaj: Yup.string().required(ValidationTranslations.requiredField),
                zyrtariEmri: Yup.string().when('konfliktNdaj', {
                    is: '1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                zyrtariMbiemri: Yup.string().when('konfliktNdaj', {
                    is: '1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                zyrtariEmail: Yup.string().nullable().email(ValidationTranslations.validEmail),
                zyrtariGjiniaId: Yup.string().when('konfliktNdaj', {
                    is: '1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                zyrtariInstitucioniId: Yup.string().when('konfliktNdaj', {
                    is: '1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                zyrtariInstitucioniTjera: Yup.string().when('zyrtariInstitucioniId', {
                    is: '-1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                zyrtariPozitaPunes: Yup.string().when('konfliktNdaj', {
                    is: '1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                emertimiOrganitKolegjial: Yup.string().when('konfliktNdaj', {
                    is: '2',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                organiKolegjialInstitucioniId: Yup.string().when('konfliktNdaj', {
                    is: '2',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                organiKolegjialInstitucioniTjeter: Yup.string().when('organiKolegjialInstitucioniId', {
                    is: '-1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                procedureNgjashmeInfoShtese: Yup.string().when('procedureNgjashmeNeProces', {
                    is: 'true',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                dataNdodhjesRastit: Yup.date().required(ValidationTranslations.requiredField),
                pershkrimi: Yup.string().required(ValidationTranslations.requiredField),
            });
        }

        return Yup.object();
    };

    let othersLocale = '';

    if (WebsiteLanguage === 'sq') {
        othersLocale = 'Tjetër';
    } else if (WebsiteLanguage === 'en') {
        othersLocale = 'Other';
    } else if (WebsiteLanguage === 'sr') {
        othersLocale = 'Ostalo';
    } else {
        othersLocale = 'Tjetër';
    };

    const institutionsDataWithStringValues = institutionsData.map(item => ({
        value: `${item.id}`,
        label: item.nameSq,
    }));

    institutionsDataWithStringValues.push({
        value: '-1',
        label: othersLocale
    });

    const handlePopup = () => {
        navigate('/');
    };

    const handlePaste = (event) => {
        event.preventDefault();
        return false;
    };

    const formik = useFormik({
        initialValues: {
            raportuesiAnonim: 'false',
            raportuesiEmri: '',
            raportuesiMbiemri: '',
            raportuesiEmail: '',
            ConfrimEmailRaportuesi: '',
            raportuesiGjiniaId: '',

            konfliktNdaj: '',
            zyrtariEmri: '',
            zyrtariMbiemri: '',
            zyrtariEmail: null,
            zyrtariGjiniaId: '',
            zyrtariInstitucioniId: '',
            zyrtariInstitucioniTjera: '',
            zyrtariPozitaPunes: '',
            emertimiOrganitKolegjial: '',
            organiKolegjialInstitucioniId: '',
            organiKolegjialInstitucioniTjeter: '',
            dataNdodhjesRastit: '',
            procedureNgjashmeInfoShtese: '',
            pershkrimi: '',
        },
        validationSchema: getValidationSchema(active),
        onSubmit: (values) => {
            let controlZyrtariInstitucioniId = values;
            if (values.zyrtariInstitucioniId === '-1') {
                controlZyrtariInstitucioniId = { ...values, zyrtariInstitucioniId: null }
            }
            let controlKonfliktNdaj = controlZyrtariInstitucioniId
            if (values.konfliktNdaj === '1') {
                controlKonfliktNdaj = { ...controlZyrtariInstitucioniId, ndajZyrtarit: true, ndajOrganitKolegjial: false }
            } else if (values.konfliktNdaj === '2') {
                controlKonfliktNdaj = { ...controlZyrtariInstitucioniId, ndajOrganitKolegjial: true, ndajZyrtarit: false }
            }
            let dateRastit = controlKonfliktNdaj
            if (values.dataNdodhjesRastit) {
                dateRastit = { ...controlKonfliktNdaj, dataNdodhjesRastit: dayjs(values.dataNdodhjesRastit).format('YYYY/MM/DD') }
            }
            postKonfliktiInteresit(dateRastit)
        },
    });

    const handleCloseButtonClick = () => {
        setNotificationBox(null);
    }

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [savedDocuments, setSavedDocuments] = useState([]);
    const [documentsModelOpen, setDocumentsModelOpen] = useState(false);
    const [deleteDocumentsIndex, setDeleteDocumentsIndex] = useState(null);

    const [NotificationBox, setNotificationBox] = useState(null);
    const [languageValue, setLanguageValue] = useState(1);
    const [checkMediaError, setCheckMediaError] = useState(false);

    useEffect(() => {
        const languageMap = {
            'sq': 1,
            'en': 2,
            'sr': 3
        };

        setLanguageValue(languageMap[WebsiteLanguage]);
    }, [WebsiteLanguage]);


    // docs function
    const handleFileChange = async (file) => {
        try {
            const lastDotIndex = file.name.lastIndexOf('.');
            const fileType = file.name.slice(lastDotIndex);

            const checkMedia = await getData(`Deklarimi/CheckMedia?size=${file.size}&format=${fileType}&webLang=${languageValue}`);

            if (checkMedia && checkMedia.status === 200) {
                setSelectedFile(file);
            } else {
                setCheckMediaError(true);
                setSelectedFileError(true);
                throw new Error('Error invalid file');
            }
        } catch (error) {
            setCheckMediaError(true);
            setSelectedFileError(true);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.CheckMediaErrorAlert}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
                setCheckMediaError(false);
                setSelectedFileError(false);
            }, 5000);
            setSelectedFile(null);
        }
    };

    const handleSave = async () => {
        try {
            if (selectedFile && documentName) {
                const updatedFile = new Blob([selectedFile], { type: selectedFile.type });
                updatedFile.name = documentName + documentType;

                const newDocument = {
                    file: updatedFile,
                };

                setSavedDocuments((prevDocuments) => [...prevDocuments, newDocument]);
                setSelectedFile(null);
                setDocumentName('');
                setDocumentType('');
                setSelectedFileError(false);
            }
        } catch (error) {
            setSelectedFile(null);
            setDocumentName('');
            setDocumentType('');
            setSelectedFileError(false);

            if (error.response && error.response.data) {
                setNotificationBox(
                    <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                        {error.response.data[0].message}
                    </Notification>
                );
                setTimeout(() => {
                    setNotificationBox(null);
                }, 5000);
            }
        }
    };
    // docs end

    const postKonfliktiInteresit = async (data) => {
        try {
            const newData = {
                ...data,
                Gjuha: WebsiteLanguage,
            }
            const konfliktiResponse = await postFormData('ConflictInteres/CreateConflictInteres', newData);
            if (konfliktiResponse) {
                setIdKonflikti(konfliktiResponse.data.raportimets[0].id)
                setReferenceKonflikti(konfliktiResponse.data.raportimets[0].referenca)
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );

            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    const konflitInteresiMedia = async () => {
        try {

            const data = {
                Files: savedDocuments,
                RaportimiId: idKonflikti,
            };

            let formData = new FormData();
            data.Files.forEach((doc) => {
                formData.append('Files', doc.file, doc.file.name);
            });

            formData.append('RaportimiId', data.RaportimiId);
            formData.append('Publik', true);

            const konfliktiResponseMedia = await postData('Deklarimi/InsertRaportimetMedia', formData);

            if (konfliktiResponseMedia) {
                setIsLoading(false);

            }

        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    useEffect(() => {
        if (idKonflikti && savedDocuments && savedDocuments.length > 0) {
            konflitInteresiMedia();
        }
    }, [idKonflikti, savedDocuments]);

    const handleNextStep = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                if (active === 1) {
                    if (selectedFile && !savedDocuments.some((doc) => doc.file === selectedFile)) {
                        setSelectedFileError(true);
                        setNotificationBox(
                            <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                                {AlertTranslations.notifyFileRequired}
                            </Notification>
                        );
                        setTimeout(() => {
                            setNotificationBox(null);
                        }, 3000);
                        return;
                    }

                    setIsLoading(true);
                    formik.handleSubmit();
                    setTimeout(() => {
                        setActive(2);
                    }, 3000);
                } else if (active < 2) {
                    setActive((current) => current + 1);
                }
            } else {
                formik.setTouched(
                    Object.keys(formik.values).reduce((acc, key) => {
                        acc[key] = true;
                        return acc;
                    }, {})
                );
            }
        });
    };


    const handleDelete = (index) => {
        setDeleteDocumentsIndex(index);
        setDocumentsModelOpen(true);
    };

    const confirmDeleteDocuments = () => {
        if (deleteDocumentsIndex !== null) {
            const updatedDocuments = [...savedDocuments];
            updatedDocuments.splice(deleteDocumentsIndex, 1);
            setSavedDocuments(updatedDocuments);
        }
        closeModalDocuments();
    };

    const closeModalDocuments = () => {
        setDocumentsModelOpen(false);
        setDeleteDocumentsIndex(null);
    };

    useEffect(() => {
        if (selectedFile) {
            const lastDotIndex = selectedFile.name.lastIndexOf('.');
            const nameWithoutExtension = selectedFile.name.slice(0, lastDotIndex);
            const fileType = selectedFile.name.slice(lastDotIndex);
            setDocumentName(nameWithoutExtension);
            setDocumentType(fileType);
        }
    }, [selectedFile])

    const clearInputValue = () => {
        setDocumentName('');
        setDocumentType('');
        setSelectedFile(null);
        setSelectedFileError(false);
    };

    return (
        <div className="apk-home">
            <div className="stepper-container">
                <div className="stepper-header">
                    <Stepper allowNextStepsSelect={false} color="#051A53" active={active} onStepClick={setActive}>
                        <Stepper.Step label={ContentTranslations.step1Name} description={ContentTranslations.step1KonfliktDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>
                                        <div className='icone'>
                                            {GeneralTranslations.interestsConflict}
                                            <Tooltip
                                                multiline
                                                sx={{ maxWidth: 500 }}
                                                position="top"
                                                className="tooltip-konflikt"
                                                withArrow arrowSize={8} label={AlertTranslations.KonfliktiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Title>
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.step1KonfliktSubTitle}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiDataTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>

                                <Radio.Group
                                    name="raportuesiAnonim"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.anonymous}
                                            <Tooltip
                                                multiline
                                                w={500}
                                                position="top" withArrow arrowSize={8} label={AlertTranslations.KonfliktiAnonimTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                    value={formik.values.raportuesiAnonim}
                                    onChange={(value) => formik.setFieldValue('raportuesiAnonim', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiAnonim && formik.errors.raportuesiAnonim}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                    </Group>
                                </Radio.Group>
                                <Group grow className="name-group">
                                    <TextInput
                                        label={GeneralTranslations.name}
                                        placeholder={GeneralTranslations.name}
                                        name='raportuesiEmri'
                                        required={formik.values.raportuesiAnonim === "false" ? true : false}
                                        onChange={formik.handleChange}
                                        value={formik.values.raportuesiEmri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.raportuesiEmri && formik.errors.raportuesiEmri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiNameTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                    <TextInput
                                        label={GeneralTranslations.lastName}
                                        placeholder={GeneralTranslations.lastName}
                                        name='raportuesiMbiemri'
                                        required={formik.values.raportuesiAnonim === "false" ? true : false}
                                        onChange={formik.handleChange}
                                        value={formik.values.raportuesiMbiemri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.raportuesiMbiemri && formik.errors.raportuesiMbiemri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        rightSection={
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiMbiemriTooltip} color="#051A53">
                                                <div className="icone">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        }
                                    />
                                </Group>
                                <TextInput
                                    label={GeneralTranslations.numriTelefonit}
                                    placeholder={GeneralTranslations.numriTelefonit}
                                    leftSectionPointerEvents="none"
                                    type="tel"
                                    name='raportuesiNrTel'
                                    onChange={(e) => formik.setFieldValue('raportuesiNrTel', e.target.value)}
                                    value={formik.values.raportuesiNrTel}
                                    leftSection={<MdOutlinePhoneEnabled />}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiTelTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={GeneralTranslations.emailAddress}
                                    // required
                                    name='raportuesiEmail'
                                    placeholder={GeneralTranslations.emailAddress}
                                    onChange={formik.handleChange}
                                    value={formik.values.raportuesiEmail}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiEmail && formik.errors.raportuesiEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEmailTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={ContentTranslations.ConfirmEmail}
                                    // required
                                    name='ConfirmEmailRaportuesi'
                                    onChange={formik.handleChange}
                                    onPaste={handlePaste}
                                    value={formik.values.ConfirmEmailRaportuesi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiEmail && formik.errors.ConfirmEmailRaportuesi}
                                    placeholder={ContentTranslations.ConfirmEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    rightSection={
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiConfirmEmailTooltip} color="#051A53">
                                            <div className="icone">
                                                <FaInfoCircle />
                                            </div>
                                        </Tooltip>
                                    }
                                />
                                <Radio.Group
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.gender}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={300} position='top' withArrow arrowSize={8} label={AlertTranslations.KonfliktiGjiniaTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    name='raportuesiGjiniaId'
                                    // withAsterisk={formik.values.raportuesiAnonim === "false" ? true : false}
                                    required
                                    value={formik.values.raportuesiGjiniaId}
                                    onChange={(value) => formik.setFieldValue('raportuesiGjiniaId', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiGjiniaId && formik.errors.raportuesiGjiniaId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label="M" />
                                        <Radio color="#051A53" value="2" label="F" />
                                    </Group>
                                </Radio.Group>
                                <Values values={formik.values} />
                            </div>
                        </Stepper.Step>
                        <Stepper.Step label={ContentTranslations.step2Name} description={ContentTranslations.step2KonfliktDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.interestsConflict}</Title>
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.officialDataKonflict}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiAgainstTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>
                                <Values values={formik.values} />
                                <Radio.Group
                                    name="konfliktNdaj"
                                    value={formik.values.konfliktNdaj}
                                    onChange={(value) => formik.setFieldValue('konfliktNdaj', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.konfliktNdaj && formik.errors.konfliktNdaj}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Tooltip multiline w={200} withArrow arrowSize={8} label={AlertTranslations.KonfliktiZyrtariTooltip} color="#051A53">
                                            <Radio color="#051A53" value="1" label={GeneralTranslations.conflictZyrtari} />
                                        </Tooltip>
                                        <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.KonfliktiOrganiTooltip} color="#051A53">
                                            <Radio color="#051A53" value="2" label={GeneralTranslations.conflictKolegjial} />
                                        </Tooltip>

                                    </Group>
                                </Radio.Group>
                                {formik.values.konfliktNdaj === "1" ? (
                                    <Fragment>
                                        <Group grow>
                                            <TextInput
                                                label={GeneralTranslations.name}
                                                name="zyrtariEmri"
                                                placeholder={GeneralTranslations.name}
                                                required
                                                onChange={formik.handleChange}
                                                value={formik.values.zyrtariEmri}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.zyrtariEmri && formik.errors.zyrtariEmri}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiEmriTooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                            <TextInput
                                                label={GeneralTranslations.lastName}
                                                placeholder={GeneralTranslations.lastName}
                                                name="zyrtariMbiemri"
                                                required
                                                onChange={formik.handleChange}
                                                value={formik.values.zyrtariMbiemri}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.zyrtariMbiemri && formik.errors.zyrtariMbiemri}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiMbiemri2Tooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                        </Group>
                                        <TextInput
                                            label={GeneralTranslations.numriTelefonit}
                                            placeholder={GeneralTranslations.numriTelefonit}
                                            leftSectionPointerEvents="none"
                                            type="tel"
                                            name='zyrtariNrTel'
                                            onChange={(e) => formik.setFieldValue('zyrtariNrTel', e.target.value)}
                                            value={formik.values.zyrtariNrTel}
                                            leftSection={<MdOutlinePhoneEnabled />}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiTel2Tooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineAlternateEmail />}
                                            label={GeneralTranslations.emailAddress}
                                            placeholder={GeneralTranslations.emailAddress}
                                            name='zyrtariEmail'
                                            onChange={(e) => formik.setFieldValue('zyrtariEmail', e.target.value)}
                                            value={formik.values.zyrtariEmail}
                                            error={formik.errors.zyrtariEmail}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiEmail2Tooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <Radio.Group
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.gender}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.KonfliktiGjinia2Tooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            name='zyrtariGjiniaId'
                                            value={formik.values.zyrtariGjiniaId}
                                            onChange={(value) => formik.setFieldValue('zyrtariGjiniaId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.zyrtariGjiniaId && formik.errors.zyrtariGjiniaId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        >
                                            <Group mt="xs">
                                                <Radio color="#051A53" value="1" label="M" />
                                                <Radio color="#051A53" value="2" label="F" />
                                            </Group>
                                        </Radio.Group>
                                        <Select
                                            searchable
                                            // clearable
                                            required
                                            key={WebsiteLanguage}
                                            data={institutionsDataWithStringValues}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.institutionLabel}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={400} withArrow arrowSize={8} label={AlertTranslations.KonfliktiInstitucioniTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.institutionLabel}
                                            name='zyrtariInstitucioniId'
                                            onChange={(selected) => {
                                                formik.setFieldValue('zyrtariInstitucioniId', selected);
                                            }}
                                            value={formik.values.zyrtariInstitucioniId}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.zyrtariInstitucioniId && formik.errors.zyrtariInstitucioniId}
                                            withAsterisk={false}
                                        // inputWrapperOrder={['label', 'error', 'select']}
                                        />
                                        {formik.values.zyrtariInstitucioniId === '-1' && (
                                            <TextInput
                                                label={GeneralTranslations.institutionName}
                                                required
                                                placeholder={GeneralTranslations.institutionName}
                                                name='zyrtariInstitucioniTjera'
                                                onChange={formik.handleChange}
                                                value={formik.values.zyrtariInstitucioniTjera}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.zyrtariInstitucioniTjera && formik.errors.zyrtariInstitucioniTjera}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                            />
                                        )}
                                        <TextInput
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.jobPosition}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={400} withArrow arrowSize={8} label={AlertTranslations.KonfliktiJobPositionTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.jobPosition}
                                            required
                                            name='zyrtariPozitaPunes'
                                            onChange={formik.handleChange}
                                            value={formik.values.zyrtariPozitaPunes}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.zyrtariPozitaPunes && formik.errors.zyrtariPozitaPunes}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        />
                                    </Fragment>
                                ) : formik.values.konfliktNdaj === "2" ? (
                                    <Fragment>
                                        <TextInput
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.organName}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiEmriOrganitKolegjialTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.organName}
                                            required
                                            name='emertimiOrganitKolegjial'
                                            onChange={formik.handleChange}
                                            value={formik.values.emertimiOrganitKolegjial}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.emertimiOrganitKolegjial && formik.errors.emertimiOrganitKolegjial}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        />
                                        <Select
                                            searchable
                                            clearable
                                            required
                                            key={WebsiteLanguage}
                                            data={institutionsDataWithStringValues}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.institutionOrgan}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiInstitucioniOrganitTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.institutionOrgan}
                                            name='organiKolegjialInstitucioniId'
                                            onChange={(selected) => {
                                                formik.setFieldValue('organiKolegjialInstitucioniId', selected);
                                            }}
                                            value={formik.values.organiKolegjialInstitucioniId}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.organiKolegjialInstitucioniId && formik.errors.organiKolegjialInstitucioniId}
                                            withAsterisk={false}
                                        // onChange={handleInstitutionChange}
                                        />
                                        {formik.values.organiKolegjialInstitucioniId === '-1' && (
                                            <TextInput
                                                label={GeneralTranslations.nameInstitution}
                                                required
                                                placeholder={GeneralTranslations.nameInstitution}
                                                name='organiKolegjialInstitucioniTjeter'
                                                onChange={formik.handleChange}
                                                value={formik.values.organiKolegjialInstitucioniTjeter}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.organiKolegjialInstitucioniTjeter && formik.errors.organiKolegjialInstitucioniTjeter}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                            />
                                        )}
                                    </Fragment>
                                ) : ''}
                                <DateInput
                                    className="form-dateInput"
                                    valueFormat="DD/MM/YYYY"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.timeCase}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiData2Tooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    placeholder="DD/MM/YYYY"
                                    clearable
                                    required
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineDateRange />}
                                    name='dataNdodhjesRastit'
                                    selected={formik.values.dataNdodhjesRastit}
                                    value={formik.values.dataNdodhjesRastit}
                                    onChange={(date) => formik.setFieldValue('dataNdodhjesRastit', date)}
                                    error={formik.touched.dataNdodhjesRastit && formik.errors.dataNdodhjesRastit}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />
                                <Radio.Group
                                    name="procedureNgjashmeNeProces"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.sameProcedure}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiProcessTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    value={formik.values.procedureNgjashmeNeProces}
                                    onChange={(value) => formik.setFieldValue('procedureNgjashmeNeProces', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.procedureNgjashmeNeProces && formik.errors.procedureNgjashmeNeProces}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                    </Group>
                                </Radio.Group>
                                {formik.values.procedureNgjashmeNeProces === "true" &&
                                    <TextInput
                                        label={
                                            <div className='icone'>
                                                {GeneralTranslations.infoDescription}
                                                <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiInformatatTooltip} color="#051A53">
                                                    <div className="icone2">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            </div>}
                                        required
                                        error={formik.touched.procedureNgjashmeInfoShtese && formik.errors.procedureNgjashmeInfoShtese}
                                        placeholder={GeneralTranslations.infoDescription}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        value={formik.values.procedureNgjashmeInfoShtese}
                                        name='procedureNgjashmeInfoShtese'
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        withAsterisk={false}
                                    />
                                }
                                <Textarea
                                    rows={6}
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.caseDescription}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiPershkrimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                    placeholder={GeneralTranslations.caseDescription}
                                    required
                                    name='pershkrimi'
                                    onChange={(e) => {
                                        if (e.target.value.length <= maxChars) {
                                            formik.handleChange(e);
                                        }
                                    }}
                                    value={formik.values.pershkrimi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.pershkrimi && formik.errors.pershkrimi}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />
                                <Text size="sm" color={formik.values.pershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                    {formik.values.pershkrimi?.length}/{maxChars}
                                </Text>
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.listDocument}
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiDokumentetTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>
                                <Group mt="xs" className="doc-input-group">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group>
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            value={documentName}
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>
                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell >  <Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Step>
                        <Stepper.Completed>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.interestsConflict}</Title>
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.officialDataKonflict}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiAgainstTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>
                                <Values values={formik.values} />
                                <Radio.Group
                                    name="konfliktNdaj"
                                    value={formik.values.konfliktNdaj}
                                    onChange={(value) => formik.setFieldValue('konfliktNdaj', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.konfliktNdaj && formik.errors.konfliktNdaj}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Tooltip multiline w={200} withArrow arrowSize={8} label={AlertTranslations.KonfliktiZyrtariTooltip} color="#051A53">
                                            <Radio color="#051A53" value="1" label={GeneralTranslations.conflictZyrtari} />
                                        </Tooltip>
                                        <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.KonfliktiOrganiTooltip} color="#051A53">
                                            <Radio color="#051A53" value="2" label={GeneralTranslations.conflictKolegjial} />
                                        </Tooltip>

                                    </Group>
                                </Radio.Group>
                                {formik.values.konfliktNdaj === "1" ? (
                                    <Fragment>
                                        <Group grow>
                                            <TextInput
                                                label={GeneralTranslations.name}
                                                name="zyrtariEmri"
                                                placeholder={GeneralTranslations.name}
                                                required
                                                onChange={formik.handleChange}
                                                value={formik.values.zyrtariEmri}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.zyrtariEmri && formik.errors.zyrtariEmri}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiEmriTooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                            <TextInput
                                                label={GeneralTranslations.lastName}
                                                placeholder={GeneralTranslations.lastName}
                                                name="zyrtariMbiemri"
                                                required
                                                onChange={formik.handleChange}
                                                value={formik.values.zyrtariMbiemri}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.zyrtariMbiemri && formik.errors.zyrtariMbiemri}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiMbiemri2Tooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                        </Group>
                                        <TextInput
                                            label={GeneralTranslations.numriTelefonit}
                                            placeholder={GeneralTranslations.numriTelefonit}
                                            leftSectionPointerEvents="none"
                                            type="tel"
                                            name='zyrtariNrTel'
                                            onChange={(e) => formik.setFieldValue('zyrtariNrTel', e.target.value)}
                                            value={formik.values.zyrtariNrTel}
                                            leftSection={<MdOutlinePhoneEnabled />}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiTel2Tooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineAlternateEmail />}
                                            label={GeneralTranslations.emailAddress}
                                            placeholder={GeneralTranslations.emailAddress}
                                            name='zyrtariEmail'
                                            onChange={(e) => formik.setFieldValue('zyrtariEmail', e.target.value)}
                                            value={formik.values.zyrtariEmail}
                                            error={formik.errors.zyrtariEmail}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiEmail2Tooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <Radio.Group
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.gender}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.KonfliktiGjinia2Tooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            name='zyrtariGjiniaId'
                                            value={formik.values.zyrtariGjiniaId}
                                            onChange={(value) => formik.setFieldValue('zyrtariGjiniaId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.zyrtariGjiniaId && formik.errors.zyrtariGjiniaId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        >
                                            <Group mt="xs">
                                                <Radio color="#051A53" value="1" label="M" />
                                                <Radio color="#051A53" value="2" label="F" />
                                            </Group>
                                        </Radio.Group>
                                        <Select
                                            searchable
                                            // clearable
                                            required
                                            key={WebsiteLanguage}
                                            data={institutionsDataWithStringValues}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.institutionLabel}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={400} withArrow arrowSize={8} label={AlertTranslations.KonfliktiInstitucioniTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.institutionLabel}
                                            name='zyrtariInstitucioniId'
                                            onChange={(selected) => {
                                                formik.setFieldValue('zyrtariInstitucioniId', selected);
                                            }}
                                            value={formik.values.zyrtariInstitucioniId}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.zyrtariInstitucioniId && formik.errors.zyrtariInstitucioniId}
                                            withAsterisk={false}
                                        // inputWrapperOrder={['label', 'error', 'select']}
                                        />
                                        {formik.values.zyrtariInstitucioniId === '-1' && (
                                            <TextInput
                                                label={GeneralTranslations.institutionName}
                                                required
                                                placeholder={GeneralTranslations.institutionName}
                                                name='zyrtariInstitucioniTjera'
                                                onChange={formik.handleChange}
                                                value={formik.values.zyrtariInstitucioniTjera}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.zyrtariInstitucioniTjera && formik.errors.zyrtariInstitucioniTjera}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                            />
                                        )}
                                        <TextInput
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.jobPosition}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={400} withArrow arrowSize={8} label={AlertTranslations.KonfliktiJobPositionTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.jobPosition}
                                            required
                                            name='zyrtariPozitaPunes'
                                            onChange={formik.handleChange}
                                            value={formik.values.zyrtariPozitaPunes}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.zyrtariPozitaPunes && formik.errors.zyrtariPozitaPunes}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        />
                                    </Fragment>
                                ) : formik.values.konfliktNdaj === "2" ? (
                                    <Fragment>
                                        <TextInput
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.organName}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiEmriOrganitKolegjialTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.organName}
                                            required
                                            name='emertimiOrganitKolegjial'
                                            onChange={formik.handleChange}
                                            value={formik.values.emertimiOrganitKolegjial}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.emertimiOrganitKolegjial && formik.errors.emertimiOrganitKolegjial}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        />
                                        <Select
                                            searchable
                                            clearable
                                            required
                                            key={WebsiteLanguage}
                                            data={institutionsDataWithStringValues}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.institutionOrgan}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiInstitucioniOrganitTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.institutionOrgan}
                                            name='organiKolegjialInstitucioniId'
                                            onChange={(selected) => {
                                                formik.setFieldValue('organiKolegjialInstitucioniId', selected);
                                            }}
                                            value={formik.values.organiKolegjialInstitucioniId}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.organiKolegjialInstitucioniId && formik.errors.organiKolegjialInstitucioniId}
                                            withAsterisk={false}
                                        // onChange={handleInstitutionChange}
                                        />
                                        {formik.values.organiKolegjialInstitucioniId === '-1' && (
                                            <TextInput
                                                label={GeneralTranslations.nameInstitution}
                                                required
                                                placeholder={GeneralTranslations.nameInstitution}
                                                name='organiKolegjialInstitucioniTjeter'
                                                onChange={formik.handleChange}
                                                value={formik.values.organiKolegjialInstitucioniTjeter}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.organiKolegjialInstitucioniTjeter && formik.errors.organiKolegjialInstitucioniTjeter}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                            />
                                        )}
                                    </Fragment>
                                ) : ''}
                                <DateInput
                                    className="form-dateInput"
                                    valueFormat="DD/MM/YYYY"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.timeCase}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiData2Tooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    placeholder="DD/MM/YYYY"
                                    clearable
                                    required
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineDateRange />}
                                    name='dataNdodhjesRastit'
                                    selected={formik.values.dataNdodhjesRastit}
                                    value={formik.values.dataNdodhjesRastit}
                                    onChange={(date) => formik.setFieldValue('dataNdodhjesRastit', date)}
                                    error={formik.touched.dataNdodhjesRastit && formik.errors.dataNdodhjesRastit}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />
                                <Radio.Group
                                    name="procedureNgjashmeNeProces"
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.sameProcedure}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.KonfliktiProcessTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    value={formik.values.procedureNgjashmeNeProces}
                                    onChange={(value) => formik.setFieldValue('procedureNgjashmeNeProces', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.procedureNgjashmeNeProces && formik.errors.procedureNgjashmeNeProces}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                    </Group>
                                </Radio.Group>
                                {formik.values.procedureNgjashmeNeProces === "true" &&
                                    <TextInput
                                        label={
                                            <div className='icone'>
                                                {GeneralTranslations.infoDescription}
                                                <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiInformatatTooltip} color="#051A53">
                                                    <div className="icone2">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            </div>}
                                        required
                                        error={formik.touched.procedureNgjashmeInfoShtese && formik.errors.procedureNgjashmeInfoShtese}
                                        placeholder={GeneralTranslations.infoDescription}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                        value={formik.values.procedureNgjashmeInfoShtese}
                                        name='procedureNgjashmeInfoShtese'
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        withAsterisk={false}
                                    />
                                }
                                <Textarea
                                    rows={6}
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.caseDescription}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiPershkrimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    }
                                    placeholder={GeneralTranslations.caseDescription}
                                    required
                                    name='pershkrimi'
                                    onChange={(e) => {
                                        if (e.target.value.length <= maxChars) {
                                            formik.handleChange(e);
                                        }
                                    }}
                                    value={formik.values.pershkrimi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.pershkrimi && formik.errors.pershkrimi}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                    withAsterisk={false}
                                />
                                <Text size="sm" color={formik.values.pershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                    {formik.values.pershkrimi?.length}/{maxChars}
                                </Text>
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.listDocument}
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.KonfliktiDokumentetTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>
                                <Group mt="xs" className="doc-input-group">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group>
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            value={documentName}
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>
                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell >  <Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Completed>
                    </Stepper>
                    <div className="apk-form-background">
                        <div className='logo'> <img src="/img/logo/web/logo-gray.png" alt="Logo" /></div>
                    </div>
                    <Link className='back-btn' to="/">{GeneralTranslations.BackToHome}</Link>
                </div>


                <div className="stepper-footer">
                    <Group justify="end" mt="xl">
                        {active >= 1 &&
                            <Button type="button" className="form-btn-back btn-base" variant="default" onClick={prevStep}>{ControlsTranslations.BackButton2}</Button>
                        }
                        <Button
                            type="submit"
                            leftSection={active === 2 && <FaCheck />}
                            className="form-btn btn-base"
                            onClick={() => {
                                handleNextStep();
                            }}
                            disabled={isLoading}
                        >
                            {isLoading ? ControlsTranslations.generating : active === 2 ? ControlsTranslations.finished : active === 1 ? ControlsTranslations.Send : ControlsTranslations.continue}
                        </Button>
                    </Group>
                </div>
            </div>
            {
                active === 2 && referenceKonflikti &&
                <Modal
                    className="raport-modal"
                    opened={true}
                    centered
                    withCloseButton={false}
                    size="lg"
                    // onClose={close}
                    overlayProps={{
                        backgroundOpacity: 0.55,
                        blur: 3,
                    }}
                >
                    <div className="completed-step">
                        <div className="completed-box">
                            <div className="text-content">
                                <Title className="form-title" order={2}>{GeneralTranslations.succes}</Title>
                                <Text className="form-desc" size="md">
                                    {GeneralTranslations.subjectNumber}
                                    <CopyToClipboard text={referenceKonflikti}>
                                        <Text
                                            td="underline"
                                            span
                                            c="blue"
                                            inherit
                                        // onClick={() => {
                                        //     setTooltipVisible(true);
                                        //     setTimeout(() => setTooltipVisible(false), 2000);
                                        // }}
                                        >
                                            {referenceKonflikti}
                                        </Text>
                                    </CopyToClipboard>
                                </Text>
                            </div>

                            <div className="completed-footer">
                                <Group justify="end">
                                    <Button className="form-btn-back btn-base">
                                        <a
                                            href={`${baseUrl}Reports/GetConflictInteresReport?type=1&ReferencaRaportimit=${referenceKonflikti}&webLangId=${languageValue}`}
                                            target="_blank"
                                        >
                                            {ControlsTranslations.download}
                                        </a>
                                    </Button>
                                    <Button className="form-btn btn-base" variant="default" onClick={handlePopup}>{ControlsTranslations.finish}</Button>
                                </Group>

                            </div>

                        </div>
                    </div>
                </Modal>
            }
            <Modal
                className="raport-modal"
                opened={documentsModelOpen}
                centered
                size="lg"
                withCloseButton={false}
                onClose={closeModalDocuments}
                overlayProps={{
                    backgroundOpacity: 0.55,
                    blur: 3,
                }}
            >
                <div className="completed-step">
                    <div className="completed-box">
                        <div className="text-content">
                            <Title className="form-title flex items-center gap-2" order={2}><FaInfoCircle color='#051A53' />  {AlertTranslations.AreYouSure}</Title>
                            <Text className="form-desc" size="md">
                                {AlertTranslations.AreYouSureDescription}
                            </Text>
                        </div>
                        <div className="completed-footer">
                            <Group justify="end">
                                <Button className="form-btn-back btn-base" variant="outline" onClick={closeModalDocuments}>
                                    {ControlsTranslations.no}
                                </Button>
                                <Button className="form-btn btn-base" variant="default" color="red" onClick={confirmDeleteDocuments}>
                                    {ControlsTranslations.yes}
                                </Button>
                            </Group>

                        </div>
                    </div>
                </div>
            </Modal>
            <div className="notification-cm">
                {NotificationBox}
            </div>
        </div>
    )
}

export default KonfliktInteresit